const ENDPOINTS = {
    LOGIN: 'login-vendor',
    LOGOUT: 'logout',
    GET_VENDOR: 'get-vendor',
    UPDATE_VENDOR: 'update-vendor',
    GET_ALL_DRIVERS: 'get-all-drivers',
    ADD_DRIVER: 'add-driver',
    UPDATE_DRIVER: 'update-driver',
    UPDATE_DRIVER_PASSWORD: 'update-driver-pass',
    GET_ALL_CARS: 'get-all-cars',
    ADD_CAR: 'add-car',
    GET_CAR: 'get-car',
    UPDATE_CAR: 'update-car',
    GET_ALL_TRIPS: 'trip/get-all',
    GET_TRIP_BY_ID: 'trip/get-full-info',
    BOOK_TRIP: 'trip/book',
    UPDATE_TRIP: 'trip/update',
    ASSIGN_DRIVER_AND_CAR: 'trip/allot-driver',
    MARK_DISPATCHED: 'trip/dispatch',
    MARK_BILLED: 'trip/bill',
    CANCEL_TRIP: 'trip/cancel',
    ADD_TRIP: 'trip/create',
    ADD_COMPLETED_TRIP: 'trip/create-completed',
    GET_ALL_COMPANIES: 'get-all-companies-by-vendor',
    ADD_COMPANY: 'create-company',
    GET_COMPANY: 'get-company-by-id',
    UPDATE_COMPANY: 'update-company',
    GET_CHARGE: 'get-existing-contract',
    ADD_CHARGE: 'add-charge',
    GET_DRIVER: 'get-driver',
    ADD_CAR_TYPE: 'add-car-type',
    GET_CAR_TYPE: 'get-car-type',
    ADD_LABEL: 'add-label',
    UPDATE_LABEL: 'update-label',
    GET_ALL_LABLE: 'get-all-label',
    GET_LABEL: 'get-label-by-id',
    ADD_TRIP_TYPE: 'add-trip-type',
    GET_TRIP_TYPE: 'get-trip-type-by-id',
    GET_ALL_TRIP_TYPE: 'get-trip-type',
    UPDATE_TRIP_TYPE: 'update-trip-type',
    GET_ALL_TAX_TYPES: 'get-tax-type',
    ADD_TAX_TYPE: 'add-tax-type',
    GET_TAX_TYPE: 'get-tax-type-by-id',
    UPDATE_TAX_TYPE: 'update-tax-type',
    GET_ALL_BILLING_ITEMS: 'get-billing-items',
    ADD_BILLING_ITEM: 'add-billing-item',
    GET_BILLING_ITEM: 'get-billing-item-by-id',
    UPDATE_BILLING_ITEM: 'update-billing-item',
    GET_EXISTING_CONTRACT_RATES: 'frontendForm/getContract',
    CREATE_UPDATE_CONTRACT: 'frontendForm/CreateUpdateContract',
    CREATE_DRAFT_INVOICE: 'create-draft-invoice',
    EDIT_DRAFT_INVOICE: 'edit-draft-invoice',
    CREATE_FINAL_INVOICE: 'save-invoice',
    GET_EXCEL_INVOICE_BY_NUMBER: 'get-excel-invoice-by-number',
    CLOSE_TRIP : 'trip/complete',
    GET_ALL_INVOICES : 'get-all-invoices',
    GET_INVOICE_BY_NUMBER : 'get-invoice-by-number',
    GET_ADDRESS_SUGGESTIONS: 'autocomplete-suggestions',
    SEND_EMAIL : 'send-email',
    GET_ALL_FUEL_TRANSACTIONS : 'get-all-fuel-transactions',
    GET_FUEL_TRANSACTION : 'get-fuel-transaction-by-id',
    EDIT_FUEL_TRANSACTION : 'edit-fuel-transaction',
    MARK_FUEL_TRANSACTION_APPROVED : 'mark-fuel-transaction-approved',
    MARK_FUEL_TRANSACTION_REJECTED : 'mark-fuel-transaction-rejected',
    ADD_FUEL_TRANSACTION : 'add-fuel-transaction',
    EXPORT_FUEL_TRANSACTIONS : 'export-fuel-transactions',
    ADD_EXPENDITURE : 'add-expenditure',
    GET_ALL_EXPENDITURE : 'get-all-expenditure',
    EDIT_EXPENDITURE : 'edit-expenditure',
    MARK_EXPENDITURE_APPROVED : 'mark-expenditure-approved',
    MARK_EXPENDITURE_REJECTED : 'mark-expenditure-rejected',
    GET_EXPENDITURE : 'get-expenditure-by-id',
    GET_PETTY_CASH : 'get-petty-cash-by-id',
    GET_ALL_PETTY_CASH : 'get-petty-cash',
    REMOVE_PETTY_CASH : 'delete-petty-cash',
    EDIT_PETTY_CASH : 'edit-petty-cash',
    ADD_PETTY_CASH : 'add-petty-cash',
    GET_PAYROLL : 'get-payroll',
    MARK_PAYLROLL_PAID : 'mark-payroll-paid',
    GET_ATTENDENCE_DRIVER : 'get-attendance-driver',
    MARK_ATTENDENCE : 'mark-attendance',
    GET_ATTENDENCE_BY_TRIP : 'get-driver-attendance-by-trips',
    GET_PAID_SLIPS : 'get-paid-slips',

    // Cloud Storage API endpoints
    STORAGE_UPLOAD: 'storage/upload',
    STORAGE_DOWNLOAD: 'storage/download',
    STORAGE_DELETE: 'storage/delete',
    STORAGE_UPLOAD_BYTES: 'storage/upload-bytes',
    STORAGE_PRESIGNED_UPLOAD: 'storage/presigned-upload-url',
    STORAGE_PRESIGNED_DOWNLOAD: 'storage/presigned-download-url',
    STORAGE_SAVE_METADATA: 'storage/save-metadata',

    GET_ALL_PERMISSION_GROUPS: 'get-all-permission-groups',
    GET_ALL_PERMISSIONS: 'get-all-permissions',
    CREATE_ROLE: 'create-role',
    GET_ALL_ROLES: 'get-all-roles',
    GET_ALL_USERS: 'get-all-users',
    CREATE_USER: 'create-user',
    GET_ALL_CITIES: 'get-all-cities',
    GET_FUEL_ANALYSIS: 'get-fuel-analysis',
    ADD_GARAGE: 'create-garage',
    GET_ALL_GARAGES: 'get-all-garages',
    GET_GARAGE: 'get-garage',
    UPDATE_GARAGE: 'update-garage',
    REMOVE_GARAGE: 'delete-garage',
    SEND_NOTIFICATION: 'send-notification',
    GET_ALERTS: 'get-alerts',
    ADD_FUEL_STATION: 'add-fuel-station',
    GET_ALL_FUEL_STATIONS: 'get-all-fuel-station',
    UPDATE_FUEL_STATION: 'edit-fuel-station'
};

export default ENDPOINTS;